import type { TableStatus } from '@/types/api';

export interface TableStatusStyle {
  color: string;
  bgColor: string;
  label: string;
  emoji: string;
}

export const TABLE_STATUS_CONFIG: Record<TableStatus, TableStatusStyle> = {
  AVAILABLE: {
    color: 'text-green-800',
    bgColor: 'bg-green-100 border-green-300',
    label: 'Available',
    emoji: '✓',
  },
  OCCUPIED: {
    color: 'text-red-800',
    bgColor: 'bg-red-100 border-red-300',
    label: 'Occupied',
    emoji: '👥',
  },
  RESERVED: {
    color: 'text-blue-800',
    bgColor: 'bg-blue-100 border-blue-300',
    label: 'Reserved',
    emoji: '📅',
  },
  CLEANING: {
    color: 'text-yellow-800',
    bgColor: 'bg-yellow-100 border-yellow-300',
    label: 'Cleaning',
    emoji: '🧹',
  },
  OUT_OF_SERVICE: {
    color: 'text-gray-800',
    bgColor: 'bg-gray-100 border-gray-300',
    label: 'Out of Service',
    emoji: '⚠️',
  },
};
